import React from "react";
import GroceryDeliveryContainer from "../../containers/GroceryContainer/GroceryDeliveryContainer";

function GroceryDeliveryPage() {
  return <GroceryDeliveryContainer />;
}

export default GroceryDeliveryPage;
